(function() {
    'use strict';

    angular.module('app.nacionalidades', []);
})();
